/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import router from '@/router';
import store from '@/store';
import auth from './auth';
import realtime from './realtime';

function createConnectionWithCurrentAuthData() {
  const token = auth.getToken();
  const userId = auth.getUserId();
  realtime.connect({ token, userId });
}

export default {
  guest(to, from, next) {
    realtime.disconnect();
    next(!auth.check());
  },

  async auth(to, from, next) {
    store.commit('uiChannel/clearUiChannel');

    if ('uiСhannel' in to.query) {
      store.commit('uiChannel/setUiChannel', to.query.uiСhannel);
    }

    try {
      if ('token' in to.query) {
        //JWT обновляем всегда
        await auth.tryToLoginByJwt(to.query.token, to.query.uiСhannel);
      }
      //если без JWT проверяем
      else if (!auth.check()) {
        next('/logout');
      }

      createConnectionWithCurrentAuthData();
      next(true);
    } catch (e) {
      console.error(e);
      next({ path: '/stub' });
    }

    // auth.clearLocalData();
    // realtime.disconnect();
    // sessionStorage.setItem('return_to', `${window.location.protocol}//${window.location.host}/builtinchat/#${to.path}`);
    // window.location = `${window.location.protocol}//${window.location.host}/login`;
    //}
  },
};
